import Backbone from 'backbone';
import MessageControlModel from './MessageControlModel';

export default Backbone.Collection.extend(
  /**
   * @lends core.widget.widgetHelpers.MessageControlCollection.prototype
   */
  {
    model: MessageControlModel,
    /**
     * @class MessageControlCollection
     * @memberof core.widget.widgetHelpers
     * @classdesc This component controls the {@link MessageControlModel} elements
     * @extends Backbone.Collection
     */
    initialize() {},
    /**
     * Add a new {@link MessageControlModel} to the collection
     * @function
     * @param {object} messageControlConfig - Data to create the candidate model
     */
    add(messageControlConfig) {
      if (this.isRepeteable(messageControlConfig)) {
        let model = new MessageControlModel(messageControlConfig);
        Backbone.Collection.prototype.add.call(this, model);
        return model.get('id');
      }
    },

    /**
     * Creates a message
     * 
     * @param {string} type 
     * @param {string} text 
     * @param {boolean} [autohide=false] 
     * @param {boolean} [repeatable=false] 
     * @param {string} [msgId=undefined] 
     */
    createMessage(type, text, autohide = false, repeatable = false, msgId = undefined) {
      let config = {
        type: type,
        text: text,
        autohide: autohide,
        repeatable: repeatable,
        msgId: msgId
      };
      this.add(config);
    },

    /**
     * removes a {@link MessageControlModel} to the collection
     * @function
     * @param {String} id - Id of the model to be deleted
     */
    removeById(id) {
      let model = this.get(id);
      this.remove(model);
    },
    /**
     * remove all {@link MessageControlModel} to the collection
     * @memberOf module:MessageControl
     * @function
     */
    clean() {
      this.reset();
    },
    /**
     * remove a {@link MessageControlModel} to the collection by message id
     * @memberOf module:MessageControl
     * @function
     * @param {String} msgId - msgId of the model to be deleted
     */
    removeByMsgId(msgId) {
      let models = this.where({ 'msgId': msgId });
      this.remove(models);
    },
    /**
     * Checks if the new message can be presented, depending it can be repeated or not
     * @memberOf module:MessageControl
     * @function
     * @param {object} messageConfig - Data to create the possible model
     * */
    isRepeteable(messageConfig) {
      let canPrint = true;
      this.each((model) => {
        if (!messageConfig.repeatable && model.attributes.text === messageConfig.text) {
          canPrint = false;
        }
      });
      return canPrint;
    }
  });



// WEBPACK FOOTER //
// ./lmm-widget/src/widget/widgetHelpers/messageControl/MessageControlCollection.js